'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCuratedCells = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var getCuratedCells = exports.getCuratedCells = function getCuratedCells(cells, layout) {
  var layoutIds = R.map(R.pipe(R.map(function (entry) {
    return R.has('dimensions', entry) ? R.pluck('id', entry.dimensions || []) : entry.id;
  }), R.unnest))(layout);
  return R.pipe(R.values, R.reduce(function (acc, cell) {
    var keys = R.map(R.pipe(R.map(function (dim) {
      var val = R.prop(dim, cell.indexedDimValIds);
      return dim + '=' + val;
    }), R.join(':')), layoutIds);
    return R.over(R.lensPath(R.props(['header', 'sections', 'rows'], keys)), function (cells) {
      return R.isNil(cells) ? [cell] : R.append(cell, cells);
    }, acc);
  }, {}))(cells);
};